export const environment = {
  production: false,
  baseUrl: 'https://api.scheduler.dev.transflo.com/SchedulerAPI',
  agendaDaysToShow: 10
};
